import { action } from 'typesafe-actions';

const entity = 'price_changes';

const ADD_PRICE_CHANGE = `${entity}/ADD_PRICE_CHANGE`;
const MERGE_PRICE_CHANGES = `${entity}/MERGE_PRICE_CHANGES`;

const actionAddPriceChange = (key: string, data: any) =>
  action(ADD_PRICE_CHANGE, { key, data });

const actionMergePriceChanges = (price_changes: any) =>
  action(MERGE_PRICE_CHANGES, price_changes);

export {
  ADD_PRICE_CHANGE,
  MERGE_PRICE_CHANGES,
  actionAddPriceChange,
  actionMergePriceChanges,
};
